import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-assets', 'labelMore', 'Показать больше');
Labels.set('ui-assets', 'labelLess', 'Показать меньше');
Labels.set(
    'ui-assets',
    'labelToggleContent',
    'В настоящее время видно {visibleAssets} из {allAssets} элементов списка.'
);
